import { Pipe, PipeTransform } from '@angular/core';
import { MenuItemDto } from '../../../services/akita/menu-item-schema/menu-item.dto';
import { DataParser } from "../../../services";

@Pipe({
  name: 'getMenuLabel'
})
export class GetMenuLabelPipe implements PipeTransform {

  protected dParser: DataParser;

  transform(menuDto: MenuItemDto, languageCode: string = 'iv', pages: any): string {

    this.dParser = new DataParser(null);

    const page = this.dParser.pullData(menuDto.menuItem, 'page');
    const pageObj = pages.find(p => p.id === page);

    let label = this.dParser.pullData(pageObj, 'pageName');

    if (!label) {
      label = this.dParser.pullData(menuDto.menuItem, 'label', languageCode);
    }

    if (!label) {
      label = this.dParser.pullData(menuDto.menuItem, 'code');
    }

    return label;
  }
}
